import { Tasks } from "@components/modules/resource-planning/tasks";
import { DemoModule, Modules } from "@components/widgets/DemoModule";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { NavigationTasks } from "@src/components/widgets/AppSubNav/NavigationTasks/NavigationTasks";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout
    fullWidth
    noGutters
    noTopMargin
    noBottomMargin
    title={t`List of tasks`}
    navigation={<NavigationTasks variant="page" />}
  >
    <DemoModule module={Modules.Projects}>
      <Tasks variant="all" />
    </DemoModule>
  </MainLayout>
);

export const Route = createFileRoute("/tasks/")({
  component: Page,
});
